const utils = {
    isArray: Array.isArray || function(value) {
        return Object.prototype.toString.call(value) === '[object Array]';
    },
    isPlainObject: function(value) {
        return !!value && Object.prototype.toString.call(value) === '[object Object]';
    },
    toArray: function(value) {
        return Array.prototype.slice.call(value);
    },
    getKeys: Object.keys || function(obj) {
        var keys = [],
            key = '';
        for (key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj,key)) keys.push(key);
        }
        return keys;
    },
    encode: function(value) {
        return String(value).replace(/[,;"\\=\s%]/g, function(character) {
            return encodeURIComponent(character);
        });
    },
    decode: function(value) {
        return decodeURIComponent(value);
    },
    retrieve: function(value, fallback) {
        return value == null ? fallback : value;
    }
};

const isThirdPartyContext = function() {
    try { return window.self !== window.top; } catch (e) { return true; }
};

const EXPIRES_MULTIPLIER = 60 * 60;

const setCookie = function(key, value, options) {
    options = utils.isPlainObject(options) ? options : { expires: options };
    var expires = options.expires !== undefined ? options.expires : '',
        expiresType = typeof(expires);
    if (expiresType === 'string' && expires !== '') expires = new Date(expires);
    else if (expiresType === 'number') expires = new Date(+new Date + 1000 * EXPIRES_MULTIPLIER * expires);
    if (expires !== '' && 'toGMTString' in expires) expires = ';expires=' + expires.toGMTString();
    var path = options.path ? ';path=' + options.path : '';
    var domain = options.domain ? ';domain=' + options.domain : '';
    var secure = options.secure ? ';secure' : '';
    var sameSite = '';
    if (isThirdPartyContext()) {
        sameSite = ';SameSite=None;Partitioned';
        secure = ';secure';
    }
    document.cookie = utils.encode(key) + '=' + utils.encode(value) + expires + path + domain + secure + sameSite;
};

const getCookie = function(key, fallback) {
    var name = utils.encode(key) + '=';
    var parts = (document.cookie || '').split(';');
    for (var i = 0; i < parts.length; i++) {
        var c = parts[i].replace(/^\s+/, '');
        if (c.indexOf(name) === 0) return utils.decode(c.substring(name.length));
    }
    return utils.retrieve(undefined, fallback);
};

module.exports = {
    getCookie,
    setCookie
}